import {bookEdited} from "../actions";
import {resetEditedBook} from "../../edit/actions";

const updateBook = (bookToUpdate) => {
    return async (dispatch) => {
        await fetch(`http://localhost:9000/books/${bookToUpdate.id}`, {
            method: "PATCH",
            body: JSON.stringify({
                name: bookToUpdate.name,
                author: bookToUpdate.author,
                thumbnail: bookToUpdate.thumbnail,
                price: bookToUpdate.price,
                rating: bookToUpdate.rating,
                featured: bookToUpdate.featured
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
            }
        });

        dispatch(bookEdited(bookToUpdate));
        dispatch(resetEditedBook());
    }
}

export default updateBook;